const SelectionType = {
    Reset: 0,
    SelectPage: 1,
    SelectAll: 2,
    ShowSelected: 3
};

export default SelectionType;
